import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { ClientPortalConfiguration } from './clientPortalConfigurationService';
import { Button, ButtonColor, ButtonSize, useFormContext } from 'ui-builder';
import useFeatureToggleService from 'feature-toggle';
import ShareClientPortalButton from './ShareClientPortalButton';

export function CopyClientPortalLinkPortal() {
  return (<span id="copy-client-portal-link" />);
}

function CopyOnlyButton(props: { data?: ClientPortalConfiguration }) {
  const [isCopied, setCopied] = useState(false);

  const formContext = useFormContext<ClientPortalConfiguration>();

  const data = formContext.data || props.data;

  if (!data?.enabled || !data._portalUrl) {
    return null;
  }

  const onClick = () => {
    navigator.clipboard.writeText(data!._portalUrl!);
    setCopied(true);

    setTimeout(() => {
      setCopied(false);
    }, 1000);
  };

  return (
    <Button
      color={isCopied ? ButtonColor.GREEN : ButtonColor.GRAY}
      isFilled={false}
      onClick={onClick}
      size={ButtonSize.MEDIUM}
      text={isCopied ? 'Link Copied' : 'Copy Portal Link'}
    />
  );
}

function ShareOrCopyButton(props: { data?: ClientPortalConfiguration }) {
  const featureToggleService = useFeatureToggleService();
  const formContext = useFormContext<ClientPortalConfiguration>();

  const data = formContext.data || props.data;

  if (featureToggleService.isClientAppEnabled()) {
    return <ShareClientPortalButton data={data} />;
  }

  return <CopyOnlyButton data={data} />;
}

export default function CopyClientPortalLinkButton(
  props: {
    data?: ClientPortalConfiguration,
  }
) {
  const container = document.getElementById('copy-client-portal-link');

  const element = <ShareOrCopyButton data={props.data} />;

  if (container) {
    return ReactDOM.createPortal(element, container);
  } else {
    return element;
  }
}
